export default __webpack_public_path__ + "static/media/icon_2d.c9f4a5c6.svg";